import { render, staticRenderFns } from "./viplevel.vue?vue&type=template&id=51b16720&scoped=true&"
import script from "./viplevel.vue?vue&type=script&lang=js&"
export * from "./viplevel.vue?vue&type=script&lang=js&"
import style0 from "./viplevel.vue?vue&type=style&index=0&id=51b16720&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b16720",
  null
  
)

export default component.exports